// users.js

import { baseURL } from 'utils/api'
import Dictionary from '../dictionary'
import axios from 'axios'

const { users } = Dictionary

const userService = {
  view: async (paramsObj) => {
    return axios.get(baseURL + users.getAllList(),{params: paramsObj})
  },
  add: async (data) => {
    return axios.post(baseURL + users.jobs(), data)
  },
  delete: async (id) => {
    return axios.delete(baseURL + users.jobsById(id))
  },
  edit: async (id, data) => {
    return axios.put(baseURL + users.updateDetailById(id), data)
  },
  getDetailById: async (id) => {
    return axios.get(baseURL + users.getDetailById(id))
  },
  getBusinessById: async (id) => {
    return axios.get(baseURL + users.getBusinessById(id))
  },
  getAuthById: async (id) => {
    return axios.get(baseURL + users.getUserAuth(id))
  },
}
export default userService